import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import RefundHeader from "../../components/Refund/RefundHeader";
import RefundList from "../../components/Refund/RefundList";

const RefundPage = () => {
  return (
    <div>
      <div className="ml-10">
        <div className="py-2">
          <Breadcrumb currentPage="Refund List" />
        </div>
        <RefundHeader />
        <RefundList />
      </div>
    </div>
  );
};

export default RefundPage;
